<script setup lang="ts">
import { computed } from 'vue'
import CButton from '@/shared/ui/CButton.vue'
import CDialog from '@/shared/ui/CDialog.vue'

interface Props {
  modelValue: boolean
}

interface Emits {
  'update:modelValue': [value: boolean]
  'confirm': []
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const isOpen = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit('update:modelValue', value),
})

function handleTelegramClick() {
  // Navigate to Telegram
  window.open('https://t.me/wb_market_assist_bot', '_blank')
  handleClose()
}

function handleClose() {
  emit('update:modelValue', false)
  emit('confirm')
}
</script>

<template>
  <CDialog
    v-model="isOpen"
    title="Информация о системе"
    width="500"
    class="!w-[90%] sm:!w-[500px]"
  >
    <div class="space-y-4">
      <div class="text-gray-700 leading-relaxed">
        <p>
          После установки фильтров поиска наша система активно приступит к
          поиску доступных слотов, соответствующих вашим критериям. Как только
          подходящий слот будет найден, вы получите уведомление на указанный при
          регистрации электронный адрес, а также в нашем Telegram-боте.
        </p>
      </div>
    </div>

    <template #footer>
      <div class="flex items-center justify-between w-full gap-1">
        <CButton
          type="primary"
          class="!bg-blue-500 hover:!bg-blue-600 !text-white"
          @click="handleTelegramClick"
        >
          <i class="icon-telegram text-xl mr-1" />
          Перейти в Telegram-боте
        </CButton>
        <CButton @click="handleClose"> Закрыть </CButton>
      </div>
    </template>
  </CDialog>
</template>
